import * as React from 'react';
import { useSelector } from 'react-redux';

import { generateVacancyLink } from './utils/generateVacancyLink';
import { getSalary } from './utils/getSalary';
import { VacancyItem } from 'shared/components/Vacancies/VacancyItem';
import { selectVacancies, selectCompanyName } from 'shared/slices';

export const VacancyItemContainer = () => {
  const { vacancies } = useSelector(selectVacancies);
  const vacancy = vacancies ? vacancies[0] : null;
  const name = useSelector(selectCompanyName);

  const { id, specialization, regionId, minSalary, maxSalary } = vacancy || {};

  const vacancyLink = React.useMemo(
    () => (regionId && name && id ? generateVacancyLink(regionId, name, id) : ''),
    [id, name, regionId],
  );

  const salary = React.useMemo(() => getSalary(minSalary, maxSalary), [maxSalary, minSalary]);

  if (!vacancy) {
    return null;
  }

  return <VacancyItem vacancyLink={vacancyLink} title={specialization || ''} salary={salary || ''} />;
};
